var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EDE3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.054 12.75a20.333 20.333 0 0 1 26.891 0 1 1 0 1 0 1.323-1.5 22.334 22.334 0 0 0-29.536 0 1 1 0 0 0 1.322 1.5zm4.752 4.752a13.667 13.667 0 0 1 17.494 0 1 1 0 1 0 1.28-1.536 15.666 15.666 0 0 0-20.053 0 1 1 0 0 0 1.28 1.536zm4.646 4.794a7 7 0 0 1 8.109 0 1 1 0 1 0 1.158-1.63 9 9 0 0 0-10.425 0 1 1 0 1 0 1.158 1.63zM19.5 26.65v1.684h-3a1 1 0 0 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3V26.83a1.005 1.005 0 0 0 0-.325v-1.171a1 1 0 0 0-2 0v1.316z",
    fill: "#500D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsid);
export default __webpack_public_path__ + "static/media/ssid.fa5113dec7f805ed3386a193d32ac07f.svg";
export { ForwardRef as ReactComponent };